export interface AddEmployeeState {
    selectedEmployees: number[];
    selectableEmployees: number[];
    selectAllLoading?: boolean;
    clickedButSelectAllWasLoading?: boolean;
}

export type SetSelectableEmployeesAction = {
    type: 'SetSelectableEmployees';
    employeeIds: number[];
};

export type CheckSingleEmployeeAction = {
    type: 'CheckSingleEmployee';
    employeeId: number;
};

export type UncheckSingleEmployeeAction = {
    type: 'UncheckSingleEmployee';
    employeeId: number;
};

export type SelectAllAction = {
    type: 'SelectAll';
};

export type UncheckAllEmployeesAction = {
    type: 'UncheckAllEmployees';
};

export type SelectAllLoadingAction = {
    type: 'SelectAllLoading';
    value: boolean;
};

export type AddEmployeeAction =
    | SetSelectableEmployeesAction
    | CheckSingleEmployeeAction
    | UncheckSingleEmployeeAction
    | UncheckAllEmployeesAction
    | SelectAllAction
    | SelectAllLoadingAction;

export function addEmployeesReducer(state: AddEmployeeState, action: AddEmployeeAction): AddEmployeeState {
    switch (action.type) {
        case 'CheckSingleEmployee':
            return {
                ...state,
                selectedEmployees: [...state.selectedEmployees, action.employeeId],
            };

        case 'UncheckSingleEmployee': {
            const index = state.selectedEmployees.findIndex((e) => e === action.employeeId);
            const selectedEmployees = [
                ...state.selectedEmployees.slice(0, index),
                ...state.selectedEmployees.slice(index + 1),
            ];
            return {
                ...state,
                selectedEmployees,
            };
        }
        case 'SelectAll':
            //if you selectAll when it is loading, you will have to selectAll at another time
            if (state.selectAllLoading) {
                return {
                    ...state,
                    clickedButSelectAllWasLoading: true,
                };
            }
            return {
                ...state,
                selectedEmployees: state.selectableEmployees,
                clickedButSelectAllWasLoading: false,
            };
        case 'UncheckAllEmployees':
            return {
                ...state,
                selectedEmployees: [],
            };
        case 'SetSelectableEmployees': {
            return {
                ...state,
                selectableEmployees: action.employeeIds,
            };
        }
        case 'SelectAllLoading':
            return {
                ...state,
                selectAllLoading: action.value,
            };
        default:
            return state;
    }
}

export function stateContainsEmployee(state: AddEmployeeState, id: number): boolean {
    return !!state.selectedEmployees.find((e) => String(e) === String(id));
}

export function stateContainsAllEmployees(state: AddEmployeeState) {
    return state.selectableEmployees.length > 0 && state.selectedEmployees.length === state.selectableEmployees.length;
}

export function stateContainsNoEmployees(state: AddEmployeeState) {
    return state.selectedEmployees.length === 0;
}

export function stateContainsSomeButNotAllEmployees(state: AddEmployeeState) {
    return !stateContainsNoEmployees(state) && !stateContainsAllEmployees(state);
}

export enum SelectAllState {
    SPINNER,
    DISABLED,
    ENABLED,
}

export function stateSelectAllState(state: AddEmployeeState): SelectAllState {
    if (state.selectAllLoading && state.clickedButSelectAllWasLoading) {
        return SelectAllState.SPINNER;
    }
    return SelectAllState.ENABLED;
}
